module.exports = __webpack_public_path__ + "static/MARCOdownarrow-138cfe47ede93ef0bb0dca5d5f3bfd6e.png";